import React from "react";
import { RefreshCw } from "lucide-react";
import { DriverJobCard } from "./DriverJobCard";

export function DriverDashboard({ currentJob, nextJob, todayJobs = [], tomorrowJobs = [], weekJobs = [], onOpenJob, onPrimaryAction, onRefresh }) {
  return (
    <div className="space-y-4" data-testid="driver-dashboard-component">
      {!currentJob && !nextJob && todayJobs.length === 0 && tomorrowJobs.length === 0 && weekJobs.length === 0 && (
        <div className="rounded-2xl border border-slate-200 bg-white p-5 text-center text-sm text-slate-600" data-testid="driver-empty-state">
          No jobs assigned right now.
        </div>
      )}

      <div className="flex items-center justify-between">
        <h2 className="text-sm font-bold uppercase tracking-[0.2em] text-slate-500">Now / Next</h2>
        <button type="button" onClick={onRefresh} data-testid="driver-refresh-button" className="inline-flex items-center gap-2 text-xs font-semibold text-sky-700">
          <RefreshCw size={13} /> Refresh
        </button>
      </div>

      {currentJob ? <DriverJobCard job={currentJob} variant="current" onOpen={onOpenJob} onPrimaryAction={onPrimaryAction} /> : <div className="rounded-2xl border border-slate-200 bg-white p-4 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">NOW</div>}
      {nextJob ? <DriverJobCard job={nextJob} variant="next" onOpen={onOpenJob} onPrimaryAction={onPrimaryAction} /> : <div className="rounded-2xl border border-slate-200 bg-white p-4 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">NEXT</div>}

      {todayJobs.length > 0 && (
        <section className="space-y-3" data-testid="driver-section-today">
          <h3 className="text-sm font-bold uppercase tracking-[0.2em] text-slate-500">Today</h3>
          {todayJobs.map((job) => <DriverJobCard key={job.id} job={job} variant="list" onOpen={onOpenJob} onPrimaryAction={onPrimaryAction} />)}
        </section>
      )}

      {tomorrowJobs.length > 0 && (
        <section className="space-y-3" data-testid="driver-section-tomorrow">
          <h3 className="text-sm font-bold uppercase tracking-[0.2em] text-slate-500">Tomorrow</h3>
          {tomorrowJobs.map((job) => <DriverJobCard key={job.id} job={job} variant="list" onOpen={onOpenJob} onPrimaryAction={onPrimaryAction} />)}
        </section>
      )}

      {weekJobs.length > 0 && (
        <section className="space-y-3" data-testid="driver-section-week">
          <h3 className="text-sm font-bold uppercase tracking-[0.2em] text-slate-500">Next 7 days</h3>
          {weekJobs.map((job) => <DriverJobCard key={job.id} job={job} variant="list" onOpen={onOpenJob} onPrimaryAction={onPrimaryAction} />)}
        </section>
      )}

      <button type="button" onClick={() => onOpenJob?.(currentJob || nextJob)} disabled={!currentJob && !nextJob} data-testid="driver-primary-full-button" className="w-full rounded-2xl bg-slate-900 px-5 py-4 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-40">
        {currentJob ? "Continue current job" : nextJob ? "Open next job" : "No active job"}
      </button>
    </div>
  );
}